import type { FaireProductEntity } from "../../entity_types/product";

export const p_cz29ns968m: FaireProductEntity = {
  token: "p_cz29ns968m",
  type: "product",
  name: "Diaper Rash Cream",
  brandToken: "b_rvn46uxywb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/4e0ed1ccda859576b7959612db6e93fdd2519d68a31c114a85b8a749c4e18138.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/947f79994242f266230ad67eee71af3e7d98f0aafd062282ef039283601ecccf.jpeg",
    "https://cdn.faire.com/fastly/fb50be82af338e7b5f0e2f5bca5ad6b29009c2ef28a8f96b0f5c1fef431b2b0b.jpeg",
  ],
  priceDollars: 8.32,
  description:
    "Pure, all-natural ingredients to soothe & protect baby's delicate skin. This is our most-loved baby product because it works so quickly to bring relief to sore chafed skin. \n(Adults can use it too it works great on any chafing or rash!)\n\n2 oz & 4 oz. Glass Jar\n\nIngredients: Coconut oil*, Calendula*, Lavender*, Chamomile*, Arrowroot Powder*, Unrefined Raw Shea Butter*, Bentonite Clay, Pure Beeswax, Non-Nano Zinc Oxide, Vit. E Oil*. *Organic ",
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:24.295Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
